// extracted by mini-css-extract-plugin
module.exports = {"text":"title-m_text__1qg-Q"};